import React, {useContext, useEffect, useState} from 'react'
import {Box} from '@mui/material'
import {useStyles} from './styles'
import {useTranslation} from 'react-i18next'
import {GalleryInfoContext} from "../../components/GalleryInfoContext";

const GalleryList = () => {
    const classes = useStyles()
    const {t} = useTranslation()
    const [imageIds, setImageIds] = useState([])
    const [gallery, setGallery] = useState('')
    const [visible, setVisible] = useState(6)
    const {galleryInfo} = useContext(GalleryInfoContext);

    // ✅ compute unique URLs directly from contactInfo
    const uniqueImageUrls = React.useMemo(
        () => Array.from(new Set(galleryInfo?.ourGalleryImages || [])),
        [galleryInfo]
    );



    useEffect(() => {
        if (!uniqueImageUrls.length) return;

        // ✅ build objects directly from URLs
        const newImageObjects = uniqueImageUrls.map((url) => ({
            id: url,
            src: url,
        }));

        setImageIds(newImageObjects);
    }, [uniqueImageUrls]); // ✅ correct dependency

    useEffect(() => {
        const getImages = async () => {
            try {
                imageIds.map(async (el) => {
                    setGallery((prev) => {
                        return [...prev, el.src]
                    })
                })
            } catch (error) {
                console.error(error)
            }
        }

        getImages()
    }, [imageIds])

    const loadMoreImages = () => {
        setVisible((prevVisibleImages) =>
            Math.min(prevVisibleImages + 6, gallery.length),
        )
    }

    return (
        <>
            {imageIds.length > 0 && (
                <>
                    <Box className={classes.test}>
                        <Box className={classes.titleWrapper}>
                            {t('common.our')}
                            <span className={classes.highlight}>{t('common.gallery')}</span>
                        </Box>
                    </Box>
                    <Box className={classes.galleryWrapper}>
                        {gallery &&
                            gallery.slice(0, visible).map((el) => {
                                return (
                                    <img src={el} key={el} alt="" className={classes.image}/>
                                )
                            })}
                        {visible < gallery.length && (
                            <div className={classes.btnWrapper}>
                                <button className={classes.seeMore} onClick={loadMoreImages}>
                                    See More
                                </button>
                            </div>
                        )}
                    </Box>
                </>
            )}
        </>
    )
}

export default GalleryList
